import { format, isToday, isYesterday } from 'date-fns';

export const dayLabelTitleOrFormat = (date: Date, formatter: string) => {
  if (isToday(date)) return 'Today';
  if (isYesterday(date)) return 'Yesterday';
  return format(date, formatter);
};
